// extracted by mini-css-extract-plugin
export default {"logo":"logo-v2_logo__ko9QY","medium":"logo-v2_medium__-sLjj"};